import axios from "axios";
import config from "config";
import urlJoin from "helpers/urljoin";

type ResponseType = {
  message: string;
  data: {
    id: number;
    created_at: string;
    updated_at: string;
    name: string;
    canonical_name: string;
    region_type: string;
    meta: {
      available: boolean;
      static_map_url: string;
      is_fast_filling: boolean;
      not_advertisable: boolean;
      locality_summary: string;
    };
    location: {
      name: string;
      state: {
        long_name: string;
        short_name: string;
      };
      country: {
        long_name: string;
        short_name: string;
      };
      primary: string;
      district: {
        long_name: string;
        short_name: string;
      };
    };
    images: {
      path: string;
      type: string;
      caption: string;
    }[];
    description: {
      name: string;
      value: string;
      display_name: string;
    }[];
    location_coordinates: string;
    location_place_id: string;
    region_no: string;
    parent_id: number;
    state: string;
    secondary_name: string;
    combined_name: string;
    canonical_primary_name: string;
    meta_name: null;
    search_name: string;
    canonical_base_name: string;
    faqs: {
      answer: string;
      question: string;
    }[];
    stories: never[];
    root_name: string;
  };
};

// Get a region regions/:id
const getRegion = async (id: string, params = {}) => {
  try {
    const { data }: { data: ResponseType } = await axios.get(
      `${config.API_URL}/api/v0/regions/${id}`,
      {
        params: { ...params, use_java_api: true },
      },
    );
    return { data };
  } catch (error: any) {
    return { error };
  }
};

export const getRegions = async (options: any = {}) => {
  options.url_path = options.url_path || "regions";
  options.url = urlJoin(config.API_URL, options.url_path);
  const params = options.params || {};
  try {
    const { data } = await axios.get(options.url, {
      params: { ...params, use_java_api: true },
    });
    return { data };
  } catch (error: any) {
    return { error };
  }
};

export default getRegion;
